"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _dec, _class;

var _react = require("react");

var _reactSideEffect = require("react-side-effect");

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppSideEffect = (_dec = (0, _reactSideEffect2.default)(function (propsList) {
  return _underscore2.default.extendOwn.apply(_underscore2.default, [{}].concat((0, _toConsumableArray3.default)(propsList.map(function (p) {
    return _underscore2.default.omit(p, "children");
  }))));
}, function (state) {
  document.body.style.backgroundColor = "#121212";

  if (_underscore2.default.isNumber(state.scrollTop)) {
    window.scroll(0, state.scrollTop);
  }
  var siteName = window.location.pathname.indexOf("blog/") > -1 ? "" : "Quixel ";
  if (state.documentTitleNoPrefix) {
    document.title = state.documentTitle;
  } else {
    document.title = siteName + (state.documentTitle ? "" + state.documentTitle : "");
  }

  if (state.documentImage) {
    // setMetaTags([{name:DOCUMENT_IMAGE, value:state.documentImage}]);
    var tagName = "image";
    var metaTags = document.getElementsByTagName("META");
    for (var j = 0; j < metaTags.length; j++) {
      var name = metaTags[j].name;
      if (name == tagName || name == "og:" + tagName || name == "twitter:" + tagName) {
        metaTags[j].content = state.documentImage;
      }
    }
  }
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AppSideEffect, _Component);

  function AppSideEffect() {
    (0, _classCallCheck3.default)(this, AppSideEffect);
    return (0, _possibleConstructorReturn3.default)(this, (AppSideEffect.__proto__ || (0, _getPrototypeOf2.default)(AppSideEffect)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppSideEffect, [{
    key: "render",
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);
  return AppSideEffect;
}(_react.Component)) || _class);
exports.default = AppSideEffect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppSideEffects/AppSideEffects.jsx
// module id = 276
// module chunks = 0